import { Container, Modal, Typography } from '@cleartrip/ct-design-components'
import React, { useState } from 'react'

import VdcEducationPage from '@/components/itinerary/Review/VdcBanner/VdcEducationPage/index'
import SmallStar from 'src/assets/svg/VDC/SmallStar'
import Star from 'src/assets/svg/VDC/Star'
import VDCBgPattern from 'src/assets/svg/VDC/VdcBgPattern'
import VdcSvg from 'src/assets/svg/VDC/VdcPrimaryBg'

function VisaDenialSrpBanner() {
  const [showPopup, setShowPopup] = useState(false)

  return (
    <Container className='flex flex-column p-relative'>
      <Container className='p-absolute'>
        <VDCBgPattern />
      </Container>

      <Container className='p-absolute' style={{ top: '24px', left: '51%' }}>
        <Star />
      </Container>

      <Container className='p-absolute' style={{ top: '14px', left: '54%' }}>
        <SmallStar />
      </Container>

      <Container>
        <Container
          className='flex flex-middle p-absolute flex-between'
          css={{
            width: '100%',
            top: '20px',
            left: '24px',
            paddingRight: '50px',
            zIndex: 2,
          }}
        >
          <Typography className='infoText mt-2' colorCode='#5F1AB6' css={{ whiteSpace: 'nowrap' }} variant='HM1'>
            Full fare refund if visa gets rejected!
          </Typography>
          <Typography className='infoText mt-2' css={{ whiteSpace: 'nowrap' }} variant='HM4'>
           Absolute <span className='fw-600' style={{ color: '#11A056' }}>FREE</span> on Cleartrip. &nbsp;
            <span
              className='infoText c-pointer'
              style={{
                textDecoration: 'none',
                color: '#0F6BFF',
                marginLeft: '5px',
              }}
              onClick={() => setShowPopup(true)}
            >
              Learn more
            </span>
          </Typography>
        </Container>

        <Container css={{ pointerEvents: 'none' }}>
          <VdcSvg />
        </Container>
      </Container>

      {showPopup && (
        <Modal
          allowBackdropClose
          hideCrossIcon={false}
          modalContentCss={{ 
            width: '100%',
            borderRadius: '32px 32px 0 0',
            position: 'absolute',
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            height: '93vh'
          }}
          open={showPopup}
          onClose={() => setShowPopup(false)}
        >
          <VdcEducationPage onClose={() => setShowPopup(false)} />
        </Modal>
      )}
    </Container>
  )
}

export default VisaDenialSrpBanner
